export { default } from './BigSliderModal';
